import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/login",
      name: "Login",
      component: () => import("@/components/Login"),
    },

    {
      path: "/NotFound",
      component: () => import("@/components/NotFound"),
      hidden: true,
    },

    {
      path: "/",
      redirect: "/dashboard",
    },

    {
      path: "/dashboard",
      name: "Dashboard",
      component: () => import("@/components/Dashboard"),
      redirect: { name: "DashboardHome" },
      meta: {
        requiresAuth: true,
      },

      children: [
        {
          path: "home",
          name: "DashboardHome",
          component: () => import("@/components/DashboardHome"),
          meta: { requiresAuth: true, title: "管理首頁" },
        },
        {
          path: "products",
          name: "Products",
          component: () => import("@/components/Products/Products"),
          meta: {
            requiresAuth: true,
            title: "商品管理",
          },
        },
        {
          path: "products/:id",
          name: "Product",
          component: () => import("@/components/Products/Product/Product"),
          meta: {
            requiresAuth: true,
            title: "商品內容",
          },
        },
        {
          path: "users",
          name: "Users",
          component: () => import("@/components/Users/Users"),
          meta: {
            requiresAuth: true,
            title: "用戶管理",
          },
        },
        {
          path: "users/:id",
          name: "User",
          component: () => import("@/components/Users/User/User"),
          meta: {
            requiresAuth: true,
            title: "用戶資料",
          },
        },
        {
          path: "impeachs",
          name: "Impeachs",
          component: () => import("@/components/Impeachs/Impeachs"),
          meta: {
            requiresAuth: true,
            title: "檢舉管理",
          },
        },
        {
          path: "impeachs/:id",
          name: "Impeach",
          component: () => import("@/components/Impeachs/Impeach/Impeach"),
          meta: {
            requiresAuth: true,
            title: "檢舉內容",
          },
        },
        {
          path: "report",
          name: "Report",
          component: () => import("@/components/Report/Report"),
          meta: {
            requiresAuth: true,
            title: "報表管理",
          },
        },
        {
          path: "contacts",
          name: "Contacts",
          component: () => import("@/components/Contacts/Contacts"),
          meta: {
            requiresAuth: true,
            title: "客服管理",
          },
        },
        {
          path: "ads",
          name: "Ads",
          component: () => import("@/components/Ads/Ads"),
          meta: {
            requiresAuth: true,
            title: "廣告管理",
          },
        },
        {
          path: "ads/:id",
          name: "Ad",
          component: () => import("@/components/Ads/Ad/Ad"),
          meta: {
            requiresAuth: true,
            title: "廣告內容",
          },
        },
        {
          path: "ads/ad/addad",
          name: "AddAd",
          component: () => import("@/components/Ads/AddAd"),
          meta: {
            requiresAuth: true,
            title: "新增廣告",
          },
        },
        {
          path: "chatrooms",
          name: "ChatRooms",
          component: () => import("@/components/ChatRooms/ChatRooms"),
          meta: {
            requiresAuth: true,
            title: "聊天室管理",
          },
        },
        {
          path: "chatrooms/:id",
          name: "ChatRoom",
          component: () => import("@/components/ChatRooms/ChatRoom/ChatRoom"),
          meta: {
            requiresAuth: true,
            title: "聊天室",
          },
        },
        {
          path: "contacts/:id",
          name: "Contact",
          component: () => import("@/components/Contacts/Contact/Contact"),
          meta: {
            requiresAuth: true,
            title: "客服內容",
          },
        },
        {
          path: "activities",
          alias: "activites",
          name: "Activities",
          component: () => import("@/components/Activities/Activities"),
          meta: {
            requiresAuth: true,
            title: "活動管理",
          },
        },
        {
          path: "activities/:id",
          alias: "activites/:id",
          name: "Activity",
          component: () => import("@/components/Activities/Activity/Activity"),
          meta: {
            requiresAuth: true,
            title: "活動內容",
          },
        },
        {
          path: "activities/activity/addactivity",
          alias: "activites/activity/addactivity",
          name: "AddActivity",
          component: () => import("@/components/Activities/AddActivity"),
          meta: {
            requiresAuth: true,
            title: "新增活動",
          },
        },
        {
          path: "members",
          name: "Members",
          component: () => import("@/components/Members/Members"),
          meta: {
            requiresAuth: true,
            title: "帳號管理",
          },
        },
        {
          path: "members/:id",
          name: "Member",
          component: () => import("@/components/Members/Member/Member"),
          meta: {
            requiresAuth: true,
            title: "帳號資料",
          },
        },
        {
          path: "members/member/addmember",
          name: "AddMember",
          component: () => import("@/components/Members/AddMember"),
          meta: {
            requiresAuth: true,
            title: "新增帳號",
          },
        },
        {
          path: "organizes",
          name: "Organizes",
          component: () => import("@/components/Organizes/Organizes"),
          meta: {
            requiresAuth: true,
            title: "組織管理",
          },
        },
        {
          path: "organizes/:id",
          name: "Organize",
          component: () => import("@/components/Organizes/Organize/Organize"),
          meta: {
            requiresAuth: true,
            title: "組織內容",
          },
        },
        {
          path: "organizes/organize/addorganize",
          name: "AddOrganize",
          component: () => import("@/components/Organizes/AddOrganize"),
          meta: {
            requiresAuth: true,
            title: "新增組織",
          },
        },
      ],
    },

    { path: "*", redirect: "/NotFound", hidden: true },
  ],
});
